(function(){
  const btn=document.querySelector('[data-menu-toggle]');
  const panel=document.querySelector('[data-menu-panel]');
  if(btn&&panel){btn.addEventListener('click',()=>{const open=panel.classList.toggle('is-open');btn.setAttribute('aria-expanded',open?'true':'false');});}
  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const wrap=gallery.closest('.product-gallery-wrap');
    if(!wrap)return;
    const slides=[...gallery.querySelectorAll('[data-product-slide]')];
    const dots=[...wrap.querySelectorAll('[data-gallery-dot]')];
    const activate=i=>dots.forEach((d,j)=>d.classList.toggle('is-active',j===i));
    let raf;
    gallery.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>{const i=Math.round(gallery.scrollLeft/Math.max(1,gallery.clientWidth));activate(Math.min(slides.length-1,Math.max(0,i)));});},{passive:true});
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>gallery.scrollTo({left:i*gallery.clientWidth,behavior:'smooth'})));
  });
})();
